import { CanvasToolbarButton } from './CanvasToolbarButton';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';
import { StickyNote } from '@sweep-io/sweep-design/dist/icons';
import { useCanvasFreeElementContext } from '../../../../sweep-canvas/canvas-element-tool/CanvasFreeElementContext';
import { useCanvasFreeElementToolbarButtonBehavior } from './useCanvasFreeElementToolbarButtonBehavior';
import { useCallback } from 'react';

export const CanvasStickyNotesToolbarButton = ({ isDisabled }: { isDisabled?: boolean }) => {
  const { createStickyNoteActive, setCreateElementActive } = useCanvasFreeElementContext();
  const { canvasStickyNotes } = useFeatureToggle();

  const setCreateStickyNoteActive = useCallback(
    (active: boolean) => setCreateElementActive(active ? 'sticky-note' : null),
    [setCreateElementActive],
  );
  const { handleToggle } = useCanvasFreeElementToolbarButtonBehavior({
    createIsActive: createStickyNoteActive,
    setCreateIsActive: setCreateStickyNoteActive,
    buttonId: 'stickyNotes',
  });

  if (!canvasStickyNotes) {
    return null;
  }

  return (
    <CanvasToolbarButton
      tooltip="Add sticky note"
      onToggle={handleToggle}
      pressed={!!createStickyNoteActive}
      disabled={isDisabled}
    >
      <StickyNote />
    </CanvasToolbarButton>
  );
};
